import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsContinueSetup } from '../RcsContinueSetup/RcsContinueSetup'
import { RcsSubmissionView } from '../RcsSubmissionView/RcsSubmissionView'
import { RcsStart } from '../RcsStart/RcsStart'

import styles from './styles.module.scss'

const RcsPageContent = observer(() => {
  const { complianceStatus } = useRcsWizardContext()

  if (complianceStatus === 'in_progress') return <RcsContinueSetup />
  if (complianceStatus) return <RcsSubmissionView />

  return <RcsStart />
})

export const RcsPage = observer(() => (
  <FullPageWrapper className={styles.page}>
    <RcsPageContent />
  </FullPageWrapper>
))
